import { getAuth } from "firebase/auth";

import FirebaseAdapter from "@wc/adapters/firebase";
import { getCurrentUser } from "@wc/domain/users";

/**
 * @returns {boolean} A successful logout or not
 */
export async function logout() {
  try {
    await FirebaseAdapter().authn.signout();
    return true;
  } catch (error) {
    console.error("unable to log out", error);
    return false;
  }
}

/**
 * Use google to log in. Create a user if they don't exist
 * @returns {boolean} A successful login
 */
export async function loginGoogle() {
  try {
    await FirebaseAdapter().authn.signInWithGoogle();
  } catch (error) {
    console.error("Unable to log in", error);
    return false;
  }

  let currentUser = null;
  try {
    currentUser = await getCurrentUser();
  } catch (error) {
    console.error("Cannot get user", error);
  }

  // If user doesn't exist in Firestore, initialize them
  if (!currentUser) {
    await FirebaseAdapter().functions.initializeNewUser();

    // Refresh token to get the new custom claims
    const authUser = getAuth().currentUser;
    if (authUser) {
      await FirebaseAdapter().authn.refreshUserToken(authUser);
    }
  }

  return true;
}
